import { FC } from "react";
import { SimpleNav } from "~/components";
import { routes } from "~/constants";
import { trackActivate as track } from "~/OnboardingApp/events";
import { usePartner } from "~/OnboardingApp/hooks";
import { Body, Meta, RedeemingLoader } from "./components";
import { useActivationSkip } from "./hooks/useActivationSkip";

export const ActivatePartnerPage: FC = () => {
  const { partnerSlugify } = usePartner();
  const { isRedeeming } = useActivationSkip();

  const previousRoute = partnerSlugify(
    routes.partnerOnboardingQuestionPhone,
  ) as typeof routes.partnerOnboardingQuestionPhone;

  // Auto-redeeming the carried QR trial (or skipping a prior redemption) — hold
  // on the loader until useActivationSkip navigates to set-password. A failed
  // auto-redeem clears isRedeeming and drops through to the manual code card.
  if (isRedeeming) return <RedeemingLoader />;

  return (
    <>
      <Meta />
      <SimpleNav handleClick={track.goToPreviousPage} previousRoute={previousRoute} />
      <Body />
    </>
  );
};
